import Reveal from "./Reveal";
import { LeafDivider } from "./icons";

const Story = () => (
    <section id="story" data-testid="story-section" className="scroll-mt-24 py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
            <LeafDivider />
            <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
                <div className="lg:col-span-4">
                    <Reveal>
                        <p className="eyebrow">Our Story</p>
                        <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-saga-red sm:text-5xl">
                            Five decades of paan, reimagined for today.
                        </h2>
                    </Reveal>
                </div>
                <div className="lg:col-span-5">
                    <Reveal delay={0.1}>
                        <p className="text-base leading-relaxed text-saga-ink/80 sm:text-lg">
                            In 1976, we began with a simple vision — to serve the finest paan with passion, quality, and care.
                        </p>
                        <p className="mt-6 text-base leading-relaxed text-saga-ink/80 sm:text-lg">
                            What started as humble paan booths alongside restaurants gradually grew into independent establishments,
                            evolving with them a tradition built on craftsmanship and the trust of our customers. Five decades later,
                            that humble beginning has become a legacy, proudly serving generations across the Twin Cities.
                        </p>
                    </Reveal>
                </div>
                <div className="lg:col-span-3">
                    <Reveal delay={0.2} className="h-full">
                        <div className="h-full overflow-hidden rounded-2xl border border-saga-red/15">
                            <img
                                src="/assets/saga-classic-paan.jpg"
                                alt="Magai Meetha — soft Maghai-leaf meetha paan with cherries, served beside the traditional brass paan box and the Saga card"
                                loading="lazy"
                                data-testid="story-image"
                                className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                            />
                        </div>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);

export default Story;
